"use strict";

class UserInviteCtrl {

    constructor($state, $http, User, $mdToast) {

        this.$state = $state;
        this.$http = $http;
        this._User = User;
        this.buttonDisabled = false;
        this.$mdToast = $mdToast;
        this.roles = [];
        this.formdata = {};

        this.fetchRoles();

        $http.get('/organisation/user-subscription')
            .then((response) => {
                this.maxreached = response.data.maxReached;
            });
    }

    cancel() {

        this.$state.go('user');
    }

    fetchRoles() {
        return this.$http.get('/roles/').then(result => {
            return this.roles = result.data.data;
        });
    }

    save($valid) {

        if (!$valid) {
            return;
        }
        this.buttonDisabled = true;

        let modelData = angular.copy(this.formdata);

        this.$http.post('/invite', modelData).then(() => {
            this.$mdToast.show(
                this.$mdToast.simple()
                    .content('User has been invited')
                    .position('top right')
                    .hideDelay(3000)
            );
            this.buttonDisabled = false;
            this.$state.go('user', {'reload': true});
        }, ({data: errors}) => {
            this.generateErrorToast(errors);
            this.buttonDisabled = false;

        });
    }

    getLast(obj){

        let keyLength = Object.keys(obj).length;
        let lastKey = keyLength - 1;
        let key1 = Object.keys(obj)[lastKey];

        let keyLength2 = Object.keys(obj[key1]).length;
        let lastKey2 = keyLength2 - 1;
        let key2 = Object.keys(obj[key1])[lastKey2];

        let lastValue = (obj[key1][key2]);
        return(lastValue);
    }

    generateErrorToast(errors){
        let errorText = Object.values(errors).join(', ');

        if (Object.keys(errors).length > 1){
            errorText = this.getLast(errors);
            let errorTextString = errorText.toString();
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.error_message?plain_error=' + encodeURIComponent(errorTextString),
                hideDelay: 3000,
                position: ('top right')
            });
        } else {
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.error_message?plain_error=' + encodeURIComponent(errorText),
                hideDelay: 3000,
                position: ('top right')
            });
        }
    }
}


UserInviteCtrl.$inject = ['$state', '$http', 'User', '$mdToast'];


module.exports = UserInviteCtrl;
